import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HotlineLpHead } from '@/feature/hotline/lp/component/HotlineLpHead';
import { HotlineLpSectionFaqItem } from '@/feature/hotline/lp/component/HotlineLpSectionFaq/HotlineLpSectionFaqItem';
import { hotlineLpSectionFaqStyle } from '@/feature/hotline/lp/component/HotlineLpSectionFaq/style';
import { FAQ_ITEM_HOTLINE } from '@/utils/constants/faq/faqHotline';
/**
 * ホットライン LP FAQ セクション
 */
export const HotlineLpSectionFaq = (props) => {
    const { className = '', id } = props;
    const items = FAQ_ITEM_HOTLINE();
    const style = hotlineLpSectionFaqStyle();
    return (_jsxs("div", Object.assign({ className: style.base({ class: className }), id: id }, { children: [_jsx(HotlineLpHead, { mainText: 'よくあるご質問', subText: 'FAQ' }), _jsx("ul", Object.assign({ className: style.list() }, { children: items.map((item, index) => (_jsx(HotlineLpSectionFaqItem, { item: item }, `HotlineLpSectionFaq_${index + 1}`))) }))] })));
};
